import { LOAD_CONFIGURATION, SET_UP_CONFIGURATION } from '../constants/ActionTypes'

import ISPyB from '../config/config.js'

export function setUpConfiguration() {
  return function (dispatch) {
    dispatch({ type: SET_UP_CONFIGURATION, payload: ISPyB.sites[0] })
  }
}

export function loadConfigurationBySite() {
  return function (dispatch) {
    dispatch({ type: LOAD_CONFIGURATION, payload: ISPyB.sites[0] })
  }
}

export function loadConfiguration() {
  return function (dispatch) {
    dispatch({ type: LOAD_CONFIGURATION, payload: ISPyB.sites })
  }
}
